import React from 'react';
import FilterButton from './FilterButton';
import FilterSection from './FilterSection';


const FilterGroup = ({
    t,
    title,
    options,
    selectedFilters,
    onFilterChange,
    justify
}) => {
    return (
        <FilterSection title={t(title)} justify={justify}>
            {options.map(option => (
                <FilterButton
                    key={`${option.key}-${option.value}`}
                    label={t(option.label)}
                    isActive={selectedFilters[option.key] === option.value}
                    onClick={() => onFilterChange(option.key, option.value)}
                    className={option.className}
                />
            ))}
        </FilterSection>
    );
};

export default FilterGroup;
